import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { Grid, Box, Typography, Card } from "@mui/material";
import {
  ImportExportOutlined,
  FlagOutlined,
  MapOutlined,
  StarOutlined,
  FormatListNumberedOutlined,
  TravelExploreOutlined,
} from "@mui/icons-material";
import useStyles from "./styles";

import { deleteGame } from "../../actions";

const games = [
  {
    name: "Flags",
    description: "Given a flag - guess the correct country",
    link: "/flags",
    icon: (
      <FlagOutlined
        sx={{
          fontSize: { xs: "30px", sm: "45px", md: "70px" },
          color: "RGBA(5,15,0,0.74)",
        }}
      />
    ),
  },
  {
    name: "Capitals",
    description: "Given a country - guess its capital city",
    link: "/capitals",
    icon: (
      <StarOutlined
        sx={{
          fontSize: { xs: "30px", sm: "45px", md: "70px" },
          color: "RGBA(5,15,0,0.74)",
        }}
      />
    ),
  },
  {
    name: "HighLow",
    description: "Two countries - pick high/low for a stat",
    link: "/highlow",
    icon: (
      <ImportExportOutlined
        sx={{
          fontSize: { xs: "30px", sm: "45px", md: "70px" },
          color: "RGBA(5,15,0,0.74)",
        }}
      />
    ),
  },
  {
    name: "Lists",
    description: "List countries for a given region and category",
    link: "/lists",
    icon: (
      <FormatListNumberedOutlined
        sx={{
          fontSize: { xs: "30px", sm: "45px", md: "70px" },
          color: "RGBA(5,15,0,0.74)",
        }}
      />
    ),
  },
  {
    name: "Maps",
    description: "Find the location of countries on a map",
    link: "/maps",
    icon: (
      <MapOutlined
        sx={{
          fontSize: { xs: "30px", sm: "45px", md: "70px" },
          color: "RGBA(5,15,0,0.74)",
        }}
      />
    ),
  },
  {
    name: "Lookup",
    description: "Sortable table of data for every country",
    link: "/lookup",
    icon: (
      <TravelExploreOutlined
        sx={{
          fontSize: { xs: "30px", sm: "45px", md: "70px" },
          color: "RGBA(5,15,0,0.74)",
        }}
      />
    ),
  },
];

const GamesMenu = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  useEffect(() => {
    return () => {
      dispatch(deleteGame());
    };
  });

  return (
    <Box
      sx={{
        width: "100%",
        margin: "auto",
        maxWidth: "1100px",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Grid
        container
        spacing={1}
        sx={{ justifyContent: "center", width: "95%" }}
      >
        {/* #c9d79e */}
        {games.map((game, idx) => {
          return (
            <Grid
              item
              xs={6}
              sm={4}
              sx={{
                cursor: "pointer",
                margin: "auto",
              }}
              key={idx + 1}
            >
              <Link to={game.link} className={classes.link}>
                <Card
                  elevation={5}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-around",
                    aspectRatio: "1/1",
                    alignItems: "center",
                    backgroundColor: "background.paper",
                    border: "2px solid transparent",
                    "&:hover": {
                      border: "2px solid #34577d",
                      transform: "scale(1.03)",
                    },
                    transition: "all .4s ease",
                  }}
                  onClick={() => {}}
                >
                  <Typography
                    variant="overline"
                    sx={{
                      fontWeight: { xs: "600", md: "700" },
                      fontSize: { xs: "24px", sm: "30px" },
                      color: "RGBA(5,15,0,0.74)",
                      margin: "0",
                    }}
                  >
                    {game.name}
                  </Typography>
                  {
                    <Card
                      elevation={10}
                      sx={{
                        aspectRatio: "1/1",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "background.default",
                        padding: "0.3rem",
                        flexDirection: "column",
                      }}
                    >
                      {game.icon}
                    </Card>
                  }
                  <Box
                    sx={{
                      width: "95%",
                      padding: "0.3rem",
                      textAlign: "center",
                    }}
                  >
                    <Typography
                      variant="caption"
                      fontWeight="100"
                      sx={{
                        fontSize: { xs: "11px", sm: "16px" },
                        color: "text.disabled",
                      }}
                    >
                      {game.description}
                    </Typography>
                  </Box>
                </Card>
              </Link>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default GamesMenu;
